import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const COMMON_FIELDS = `
  id

  projects {
    id
    name
    editedAt

    savedVariations {
      edges {
        node {
          id
        }
      }
    }
  }
`;

const QUERY = gql`
  query BriefProjects($id: ID!) {
    brief(id: $id) {
      ... on UnifiedProductBrief {
        ${COMMON_FIELDS}
      }

      ... on UnifiedContentBrief {
        ${COMMON_FIELDS}
      }
  
      ... on ContentCopyBrief {
        ${COMMON_FIELDS}
      }
  
      ... on ProductCopyBrief {
        ${COMMON_FIELDS}
      }
      
      ... on ProductUnstructuredBrief {
        ${COMMON_FIELDS}
      }
      
      ... on ProductUrlUnstructuredBrief {
        ${COMMON_FIELDS}
      }
    }
  }
`;

export default (id) =>
  apolloClient
    .query({
      query: QUERY,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    .then(({ data }) => getSingleProp(data).projects);
